/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as MeRouteImport } from './routes/me'
import { Route as TravelersRouteImport } from './routes/travelers'
import { Route as HistoryIndexRouteImport } from './routes/history.index'
import { Route as HistoryConversationIdRouteImport } from './routes/history.$conversationId'
import { Route as OrdersIndexRouteImport } from './routes/orders.index'
import { Route as OrdersOrderNoRouteImport } from './routes/orders.$orderNo'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const MeRoute = MeRouteImport.update({
  id: '/me',
  path: '/me',
  getParentRoute: () => rootRouteImport,
} as any)
const TravelersRoute = TravelersRouteImport.update({
  id: '/travelers',
  path: '/travelers',
  getParentRoute: () => rootRouteImport,
} as any)
const HistoryIndexRoute = HistoryIndexRouteImport.update({
  id: '/history/',
  path: '/history/',
  getParentRoute: () => rootRouteImport,
} as any)
const HistoryConversationIdRoute = HistoryConversationIdRouteImport.update({
  id: '/history/$conversationId',
  path: '/history/$conversationId',
  getParentRoute: () => rootRouteImport,
} as any)
const OrdersIndexRoute = OrdersIndexRouteImport.update({
  id: '/orders/',
  path: '/orders/',
  getParentRoute: () => rootRouteImport,
} as any)
const OrdersOrderNoRoute = OrdersOrderNoRouteImport.update({
  id: '/orders/$orderNo',
  path: '/orders/$orderNo',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/me': typeof MeRoute
  '/travelers': typeof TravelersRoute
  '/history/$conversationId': typeof HistoryConversationIdRoute
  '/orders/$orderNo': typeof OrdersOrderNoRoute
  '/history/': typeof HistoryIndexRoute
  '/orders/': typeof OrdersIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/me': typeof MeRoute
  '/travelers': typeof TravelersRoute
  '/history/$conversationId': typeof HistoryConversationIdRoute
  '/orders/$orderNo': typeof OrdersOrderNoRoute
  '/history': typeof HistoryIndexRoute
  '/orders': typeof OrdersIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/me': typeof MeRoute
  '/travelers': typeof TravelersRoute
  '/history/$conversationId': typeof HistoryConversationIdRoute
  '/orders/$orderNo': typeof OrdersOrderNoRoute
  '/history/': typeof HistoryIndexRoute
  '/orders/': typeof OrdersIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/me'
    | '/travelers'
    | '/history/$conversationId'
    | '/orders/$orderNo'
    | '/history/'
    | '/orders/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/me'
    | '/travelers'
    | '/history/$conversationId'
    | '/orders/$orderNo'
    | '/history'
    | '/orders'
  id:
    | '__root__'
    | '/'
    | '/me'
    | '/travelers'
    | '/history/$conversationId'
    | '/orders/$orderNo'
    | '/history/'
    | '/orders/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  MeRoute: typeof MeRoute
  TravelersRoute: typeof TravelersRoute
  HistoryConversationIdRoute: typeof HistoryConversationIdRoute
  OrdersOrderNoRoute: typeof OrdersOrderNoRoute
  HistoryIndexRoute: typeof HistoryIndexRoute
  OrdersIndexRoute: typeof OrdersIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/me': {
      id: '/me'
      path: '/me'
      fullPath: '/me'
      preLoaderRoute: typeof MeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/travelers': {
      id: '/travelers'
      path: '/travelers'
      fullPath: '/travelers'
      preLoaderRoute: typeof TravelersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/history/': {
      id: '/history/'
      path: '/history'
      fullPath: '/history/'
      preLoaderRoute: typeof HistoryIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/history/$conversationId': {
      id: '/history/$conversationId'
      path: '/history/$conversationId'
      fullPath: '/history/$conversationId'
      preLoaderRoute: typeof HistoryConversationIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/orders/': {
      id: '/orders/'
      path: '/orders'
      fullPath: '/orders/'
      preLoaderRoute: typeof OrdersIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/orders/$orderNo': {
      id: '/orders/$orderNo'
      path: '/orders/$orderNo'
      fullPath: '/orders/$orderNo'
      preLoaderRoute: typeof OrdersOrderNoRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  MeRoute: MeRoute,
  TravelersRoute: TravelersRoute,
  HistoryConversationIdRoute: HistoryConversationIdRoute,
  OrdersOrderNoRoute: OrdersOrderNoRoute,
  HistoryIndexRoute: HistoryIndexRoute,
  OrdersIndexRoute: OrdersIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
